const audit = {
  sections: {
    a: {
      name: '1. Timeliness & Details',
      title: 'C/YP’s individual details, clinician’s details and timeframes.',
      grades: [1, 2, 3, 4], // 1 = outstanding, 4 = inadequate, 0 = not applicable,
      weighting: 0.15,
      negatable: {
        outstanding: [],
        good: [2, 3, 4],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'There is a comprehensive and accurate overview of all basic details',
          'There is clarity on who has written the advice, when it was written and that is was submitted within the statutory deadline (unless a legal exemption)',
          'The theme is easy to read and follow for parent and carers and professionals'
        ],
        good: [
          'Details of the clinician (name and role) who has completed the advice is clearly stated',
          'Involvement of the clinician and/or the service is clearly stated.',
          "Child / young person's details are provided and are correct (e.g.name, DOB, pronoun etc)",
          'Advice provided within 6 weeks of the date of request from the local authority',
          'Where advice is out with the 6-week timeframe legal exemption is clearly stated  (E.G. Was not brought to appointment - and it is clear that reasonable efforts have been made to contact the family to ensure advice can be provided)',
          'Advice is dated and signed'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'Details of the clinician (name and role) who has completed the advice are not clearly stated',
          'Involvement of the clinician and/or the service is not clearly stated.',
          "Child\\young person's details are provide and are correct(e.g.name, DOB, pronoun etc)",
          'Advice has not been provided within 6 weeks of the date of request from the local authority',
          'Where advice is out with the 6-week timeframe no legal exemption was stated or evident',
          'Advice is not dated and signed'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          'This theme has little structure or coherence'
        ]
      },
      tooltip: {
        good: [
          'The child / young person’s details are present and accurate (e.g. name, date of birth, pronoun etc.), along with the professional’s details from the service who undertook the assessment and wrote the report. The date is recorded and there is information that indicates whether the report was submitted within the statutory timeframes.'
        ]
      }
    },
    b: {
      name: '2. SEN Health Needs',
      title: 'C/YP’s health needs related to SEND.',
      grades: [1, 2, 3, 4, 'na'],
      weighting: 0.15,
      negatable: {
        outstanding: [],
        good: [],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'The theme comprehensively provides clarity and specificity about all of the CYP’s identified SEN-related health needs',
          'Clear explanations in accessible language are included for all formal diagnoses',
          'The theme is easy to read and follow for parents and carers and professionals'
        ],
        good: [
          'Where relevant, diagnosis is clearly stated with clear description of condition',
          'Impact of presenting needs are clearly described',
          'All health needs are clearly identified',
          'If used, formal assessments are described and results explained detailing the potential impact on the child',
          'Grammar statements including no acronyms have been used or have been clearly explained where they have been included',
          'The theme is clear, concise, understandable and accessible to parents/carers, CYP and providers/practitioners'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'Where relevant, diagnosis is not clearly stated and there is no clear description of condition',
          'Impact of presenting needs are not clearly described',
          'All health needs have not been clearly identified',
          'If used, formal assessments have not been described and there is a limited explanation of the results detailing the potential impact on the child',
          'Acronyms have been used and not been clearly explained where they have been included',
          'There is limited clarity and the theme would not be understandable and accessible to parents/carers, CYP and providers/practitioners'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          "The child's SEN related health needs are not clearly identified or in this theme",
          'This theme has little structure or coherence'
        ],
        not_applicable: [
          // 'It is clearly and comprehensively stated when there are no health needs (e.g. “According to all professional advice used to draft this QHA, NAME has no identified exceptional health needs”).'
          'This theme is not applicable for this C/YP'
        ]
      },
      tooltip: {
        good: [
          'Through liaison with the SALT, it is apparent that John has progressed significantly with his social communication and ability to interact with individuals he is not as familiar with (e.g. bus driver, shop assistant, reception staff etc).  John’s parents communicate that they are keen for outcomes to be identified that are linked to preparing for adulthood theme s and we have linked the outcomes with a focus on employability and independence (linked to John’s aspirations to work in the hospitality industry)'
        ]
      }
    },
    c: {
      name: '3. Non SEN Health Needs',
      title: 'C/YP’s wider health needs.',
      grades: [1, 2, 3, 4, 'na'],
      weighting: 0.1,
      negatable: {
        outstanding: [],
        good: [],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'The theme comprehensively provides clarity and specificity about all of the CYP’s identified non-related SEND health needs',
          'Clear explanations in accessible language are included for all formal diagnoses',
          'The theme is easy to read and follow for parents and carers and professionals'
        ],
        good: [
          'Where relevant, diagnosis is clearly stated with clear description of condition',
          'Impact of presenting needs are clearly described',
          'All health needs are clearly identified',
          'If used, formal assessments are described and results explained detailing the potential impact on the child',
          'Grammar statements including no acronyms have been used or have been clearly explained where they have been included',
          'The theme is clear, concise, understandable and accessible to parents/carers, CYP and providers/practitioners'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'Where relevant, diagnosis is not clearly stated and there is no clear description of condition',
          'Impact of presenting needs are not clearly described',
          'All health needs have not been clearly identified',
          'If used, formal assessments have not been described and there is a limited explanation of the results detailing the potential impact on the child',
          'Acronyms have been used and not been clearly explained where they have been included',
          'There is limited clarity and the theme would not be understandable and accessible to parents/carers, CYP and providers/practitioners'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          "The child's non-related SEN related health needs are not clearly identified or in this theme",
          'This theme has little structure or coherence'
        ],
        not_applicable: [
          // 'It is clearly and comprehensively stated when there are no health needs (e.g. “According to all professional advice used to draft this QHA, NAME has no identified exceptional health needs”).'
          'This theme is not applicable for this C/YP'
        ]
      },
      tooltip: {
        good: [
          'Kyle is a 14yr old boy with Type 1 diabetes and requires a continuous glucose monitoring pump to prevent his Hypoglycaemia (Low) blood sugar and hyperglycemia (high) blood sugars which will be in the range of XXX limits to keep him stable.'
        ]
      }
    },
    d: {
      name: '4. Outcomes',
      title: 'The outcomes sought for the child or the young person.',
      grades: [1, 2, 3, 4],
      weighting: 0.1,
      negatable: {
        outstanding: [],
        good: [],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'Outcomes provided are clear and specific enough that well documented, planned milestones towards achievements have been agreed',
          `The theme comprehensively provides:
            • a clear golden thread between the CYP’s aspirations, their needs and what is important to them
            • the progress they should make towards achieving their aspirations`,
          'The theme is easy to read and follow for parents and carers and professionals'
        ],
        good: [
          'Every need identified has an outcome',
          'Outcomes are SMART (Specific, Measurable, Achievable, Relevant, Time-bound)',
          'Outcomes are specific to meeting the health needs',
          'Outcomes stated are within professional boundary',
          'Grammar statements including no acronyms have been used or have been clearly explained where they have been included',
          'The theme is clear, concise, understandable and accessible to parents/carers, CYP and providers/practitioners',
          'Recommendations/comments appear within professional boundary'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'Outcomes are not SMART (Specific, Measurable, Achievable, Relevant, Time-bound)',
          'Outcomes are not specific to meeting the health needs',
          'Outcomes stated do not appear to be within the professional boundary',
          'Acronyms have been used or have been clearly explained where they have been included',
          'Acronyms have been used and not been clearly explained where they have been included',
          'There is limited clarity and the theme would not be understandable and accessible to parents/carers, CYP and providers/practitioners',
          'Recommendations/comments does not appear within professional boundary'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          "Very few or no outcomes provided and are not relevant for C/YP's needs",
          'This theme has little structure or coherence'
        ]
      },
      tooltip: {
        good: [
          'Leo will be able to access the whole school day independently and move around his education environment safley with reduced risk of any injury. He will manage all transitions between classrooms with his mobility aid and be on time for 90% of his lessons during the course of a school week'
        ]
      }
    },
    e: {
      name: '5. Provision',
      title:
        'The special educational provision required by the child or the young person.',
      grades: [1, 2, 3, 4],
      weighting: 0.15,
      negatable: {
        outstanding: [],
        good: [],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'The level of qualification and experience required for particular interventions is clearly outlined',
          'The theme comprehensively provides a clear golden thread between the CYP’s needs, provision and how the provision will support the achievement of the outcomes',
          'The theme is easy to read and follow for parents and carers and professionals'
        ],
        good: [
          'Provision is stated for every outcome identified',
          'Provision states frequency of delivery of interventions',
          'Provision states role of the person who will deliver interventions',
          'Provision states any training needed to deliver interventions',
          'Provision stated is SMART',
          'Grammar statements including no acronyms have been used or have been clearly explained where they have been included',
          'The theme is clear, concise, understandable and accessible to parents/carers, CYP and providers/practitioners',
          'Recommendations/comments appear within professional boundary'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'Provision has not been stated for every outcome identified',
          'Provision does not state frequency of delivery of interventions',
          'Provision does not state the role of the person who will deliver interventions',
          'Provision does not state any training needed to deliver interventions',
          'Provision stated is not SMART',
          'Acronyms have been used and not been clearly explained where they have been included',
          'There is limited clarity and the theme would not be understandable and accessible to parents/carers, CYP and providers/practitioners',
          'Recommendations/comments does not appear within professional boundary'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          "Very few or no outcomes provided and are not relevant for C/YP's needs",
          'This theme has little structure or coherence'
        ]
      },
      tooltip: {
        good: [
          'Kyle has global developmental delay, and severe cerebral palsy and requires 1:1 to support his communication and mobility requirements. He also has type 1 diabetes therefore the trained 1:1 will also adhere to all his medical needs in the classroom. The 1:1 will be the 2nd checker for the administration of insulin. They will require training by the Specialist diabetes nurse annually and they will follow an annual update to sign off competencies. There will be a trained school nurse on-site at the specialist school provision to support the 1:1 if required during the school day.'
        ]
      }
    },
    f: {
      name: '6. Co-production',
      title: 'Engagement and collaboration with C/YP and parents / carers.',
      grades: [1, 2, 3, 4, 'na'],
      weighting: 0.1,
      negatable: {
        outstanding: [],
        good: [],
        requires_improvement: [],
        inadequate: []
      },
      criteria: {
        outstanding: [
          'The theme meets the criteria for a good judgement consistently and securely',
          'Co-production is clearly evident throughout the advice',
          "The C/YP's and parent carer's contributions to the process are clearly evident"
        ],
        good: [
          'Clear description of child expectation of service involvement (aspiration of the child)',
          'Clear description of the parents expectation of service involvement (aspiration of the parent)',
          'Evidence outcomes are related to the expectation of the service',
          'Evidence the advice has been peer reviewed'
        ],
        requires_improvement: [
          'The quality of the theme does not consistently meet the good criteria (Less than 50% of good criteria not met). The theme is not yet good because (from the list below, please select which RI criteria applies to this theme of the plan):',
          'There is a limited (or no) description of child expectation of service involvement (aspiration of the child)',
          "There is a limited (or no) description of the parent's expectation of service involvement (aspiration of the parent)",
          'Unclear if the advice has been peer reviewed'
        ],
        inadequate: [
          'This theme is blank, or has very limited information present',
          'The theme relates to a different child (different name, DOB, gender)',
          'There is no evidence of co-production',
          'This theme has little structure or coherence'
        ],
        not_applicable: [
          // 'It is clearly and comprehensively stated when there are no health needs (e.g. “According to all professional advice used to draft this QHA, NAME has no identified exceptional health needs”).'
          'This theme is not applicable for this C/YP'
        ]
      },
      tooltip: {
        good: [
          'Katy is a 9yr old girl currently in KS2 who is severely visually impaired and requires adapted resources. Katy’s visual impairment impacts her learning at school with regard to mobility around the setting and her ability to access the curriculum, requiring additional support to ensure an inclusive environment is provided.'
        ]
      }
    }
  },
  // additionalComponents: {
  //   title: '7. Additional Components',
  //   grades: [true, false],
  //   criteria: {
  //     optional: [
  //       'Evidence the advice has been peer reviewed',
  //       'Advice is dated and signed',
  //       'Recommendations/comments appear within professional boundary'
  //     ]
  //   }
  // },
  nextSteps: {
    title: '8. Next Steps',
    grades: [true, false],
    criteria: {
      essential: [
        'Indication as to whether the QHA is a draft or final',
        'The date on which the QHA was finalised',
        'A signature from a duly authorised Local Authority officer'
      ]
    }
  }
}

module.exports = audit
